"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _stencilReactThemeDefault = require("@amzn/stencil-react-theme-default");
var _context = require("../context");
var _propTypes = require("../prop-types");
var _utils = require("../utils");
const SpacerPropTypes = {
  ..._propTypes.displayPropTypes,
  ..._propTypes.flexPropTypes,
  ..._propTypes.flexShrinkPropTypes,
  ..._propTypes.widthWithMinMaxPropTypes,
  ..._propTypes.heightWithMinMaxPropTypes
};
const Spacer = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterPropsFromPropTypes)(SpacerPropTypes)
})(_ref => {
  let {
    ...props
  } = _ref;
  return {
    ...(0, _utils.getPropsStyles)(['flex'], props),
    ...(0, _utils.getSpacingStyles)(['width', 'height', 'minWidth', 'maxWidth', 'minHeight', 'maxHeight', 'margin', 'padding'], props, _stencilReactThemeDefault.spacePropAdapter),
    display: props.display,
    flexShrink: props.flexShrink
  };
});
Spacer.displayName = 'Spacer';
Spacer.defaultProps = {
  flexShrink: 1
};
const SpacerWithDocs = (0, _stencilReactDesc.describe)(Spacer).description('Adds blank space between other elements on the page.');
SpacerWithDocs.propTypes = SpacerPropTypes;
var _default = exports.default = SpacerWithDocs;